import { useLocation } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { SITE_URL, paginaDe } from "./datos";
import { metaDe } from "./metaRuta";

const enlaceDe = (pathname) => (pathname === "/" ? `${SITE_URL}/` : `${SITE_URL}${pathname}`);

// Texto automático (sin el enlace): se usa si la página no tiene uno propio en Administración SEO.
export function textoAutomatico(pathname, d) {
  if (pathname === "/") return "Te recomiendo NuvliPro, el programa de presupuestos de reformas para autónomos y empresas de Canarias:";
  const titulo = (metaDe(pathname, d)?.title || "NuvliPro").replace(/\s*\|\s*NuvliPro$/, "");
  return `Te recomiendo esta página de NuvliPro: ${titulo}`;
}

// El enlace de la página va siempre al final.
export function textoCompartir(pathname, d) {
  const propio = paginaDe(d, pathname)?.texto_whatsapp?.trim();
  return `${propio || textoAutomatico(pathname, d)} ${enlaceDe(pathname)}`;
}

// Botón «Compártelo por WhatsApp» con el texto y el enlace de la página ya escritos (funciona también sin JavaScript).
export function CompartirWhatsApp({ d }) {
  const { pathname } = useLocation();
  const href = `https://wa.me/?text=${encodeURIComponent(textoCompartir(pathname, d))}`;
  return (
    <section className="px-5 py-12" data-testid="web-compartir">
      <div className="mx-auto flex max-w-6xl flex-col items-start justify-between gap-5 rounded-3xl border border-emerald-100 bg-white p-7 shadow-sm sm:flex-row sm:items-center sm:p-9">
        <div>
          <p className="font-heading text-lg font-bold text-[#0A2540]">¿Conoces a alguien a quien le pueda servir?</p>
          <p className="mt-1 text-sm text-slate-600">Envíale esta página por WhatsApp: el mensaje y el enlace ya van escritos.</p>
        </div>
        <a href={href} target="_blank" rel="noopener noreferrer" data-testid="web-compartir-whatsapp"
          className="inline-flex shrink-0 items-center gap-2 rounded-full bg-[#25D366] px-6 py-3 text-sm font-bold text-[#073B1F] shadow-lg shadow-emerald-500/25 transition-[transform,background-color] duration-200 hover:-translate-y-0.5 hover:bg-[#1EBE5A]">
          <MessageCircle className="h-5 w-5" /> Compártelo por WhatsApp
        </a>
      </div>
    </section>
  );
}
